<template>
    <div>
        <div class="panel-tag mt-3" v-if="commissionItems.length == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-else class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table
                        class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline"
                        role="grid"
                        style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">
                                    {{ tblHeader.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, k) in commissionItems" :key="k">
                                <td class="" v-if="k % 7 === 0" :rowspan="k % 7 === 0 ? 7 : 0"><div v-html="item['staffName']"></div></td>
                                <!-- <td class="" v-if="k % 5 === 0" :rowspan="k % 5 === 0 ? 5 : 0">{{ item['position'] }}</td> -->
                                <td class="">{{ item['type'] }}</td>
                                <td class="">{{ formatPrice(item['salesTotal']) }}</td>
                                <td class="">{{ formatPrice(item['beforeSplit']) }}</td>
                                <td class="">
                                    <div v-if="Object.keys(item['splitStylist']).length > 0">
                                        <b>Stylist</b>
                                        <div v-for="(amount, staff) of item['splitStylist']" :key="'splitStylist' + staff">
                                            {{ staff }} - {{ formatPrice(amount || 0) }}
                                        </div>
                                        <br>
                                    </div>
                                    <div v-if="Object.keys(item['splitAssistant']).length > 0">
                                        <b>Assistant</b>
                                        <div v-for="(amount, staff) of item['splitAssistant']" :key="'splitAssistant' + staff">
                                            {{ staff }} - {{ formatPrice(amount || 0) }}
                                        </div>
                                        <br>
                                    </div>
                                    <div v-if="Object.keys(item['splitReception']).length > 0">
                                        <b>Reception</b>
                                        <div v-for="(amount, staff) of item['splitReception']" :key="'splitAssistant' + staff">
                                            {{ staff }} - {{ formatPrice(amount || 0) }}
                                        </div>
                                        <br>
                                    </div>
                                    <div v-if="item['splitSelf']">
                                        <b>Solo</b>
                                        <div>
                                            {{ item['staffName'] }} - {{ formatPrice(item['splitSelf']) }}
                                        </div>
                                        <br>
                                    </div>
                                </td>
                                <td class="">{{ formatPrice(item['totalEffort']) }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- <div class="fs-xs fw-300 text-right pt-2 pb-2">
                        <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed mr-2" @click="showAllDetails">{{isExpand == 'Expand' ? $t('button_link.expand_details') : $t('button_link.collapse_details')}} </button>
                    </div> -->
                    <!-- <b-table id="salesItemTable" small striped hover bordered :fields="fields" :items="commissionItems" responsive>
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(title)="data">
                            <a class="fw-500 text-primary link" title="View Details" :id="'salesItems_' + data.item.completedID" @click="showDetails($event)">{{data.item.item.title}}</a>
                            <div class="mt-1 salesItemDetail" style="display: none;">
                                <b-table-simple class="table table-sm table-hover table-bordered table-striped">
                                    <b-tr>
                                        <b-th>{{$t('table.header.date')}}</b-th>
                                        <b-td>{{convertTimestampToDateTime(data.item.createDate)}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.receipt_number')}}</b-th>
                                        <b-td>
                                            <a class="fw-400 text-primary link" title="View Receipt" @click="generateReceipt(data.item.salesID)">
                                                {{insertLeadingZero(data.item.receiptID)}}
                                                <i class="fal fa-print"></i>
                                            </a>
                                        </b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.outlet')}}</b-th>
                                        <b-td>{{getOutletName(data.item.outletID)}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('subMenu.my_salon_member') + $t('table.header.name')}}</b-th>
                                        <b-td>{{data.item.member.displayName}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.contact')}}</b-th>
                                        <b-td>
                                            <a class="fw-400 text-primary link" title="Edit Member">
                                                {{data.item.member.mobile}}
                                                <i class="fal fa-pen"></i>
                                            </a>
                                        </b-td>    
                                    </b-tr>
                                </b-table-simple>    
                            </div>
                        </template>
                        <template #cell(staffName)="data">{{data.item.staffName}}</template>
                        <template #cell(position)="data">{{data.item.position}}</template>
                        <template #cell(type)="data">{{data.item.type}}</template>
                        <template #cell(sales)="data">{{formatPrice(data.item.sales)}}</template>
                        <template #cell(calculation)="data"><div v-html="data.item.calculation"></div></template>
                        <template #cell(total)="data">{{formatPrice(data.item.total)}}</template> -->
                        
                        <!-- <template #custom-foot>
                            <b-tr>
                                <b-td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalPrice)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalDiscount)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalOutstandings)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalTax)}}</b-td>
                                <b-td class="border-top-bottom-2 disabled-td"></b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.subTotal)}}</b-td>
                                <b-td class="border-top-bottom-2 disabled-td"></b-td>
                            </b-tr>
                        </template> -->
                    <!-- </b-table> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {calculateSalesReportTotal, getSubTotal} from '@/assets/js/dashboard/salonReport/salonReport.js'
import {getOutletName, handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
import {formatPrice, insertLeadingZero} from '@/assets/js/dashboard/utilities.js'
export default {
    name: "salesDate",
    props:{
        commissionSalesItem: { type: Array }
    },
    data(){
        return{
            commissionItems: [], 
            objTotalData: {},
            isExpand: "Expand",
        }
    },
    computed:{
        fields(){
            let list = [
                {key: "staffName", label: 'Staff', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                // {key: "position", label: 'Position', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "type", label: "Type", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "salesTotal", label: 'Effort', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "beforeSplit", label: 'Commission Before Split', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "split", label: 'Split', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "totalEffort", label: 'Commission', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
            ]

            return list
        }
    },
    methods:{
        getOutletName(id){
            return getOutletName(id, JSON.parse(this.$store.state.outlets));
        },
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24);
        },
        formatPrice(p){
            if(p === '' || p === null || p === undefined) {
                return ''
            }
            return formatPrice(p);
        },

        sortTable(a, b, key){
            if(key == "title"){
                var aTitle = a.item.title
                var bTitle = b.item.title
                return aTitle.localeCompare(bTitle);
            }else if(key == 'subTotal'){
                var aTotal = getSubTotal(a.price, a.discount, a.outstandings, a.tax.taxType, a.tax.tax)
                var bTotal = getSubTotal(b.price, b.discount, b.outstandings, a.tax.taxType, a.tax.tax)
                return aTotal - bTotal
            }
            return false
        },
        updateTable(items, filterObj){
            this.commissionItems = items
            this.setExportData(items, filterObj)
        },
        getTotalData(item){
            var objTotalData = calculateSalesReportTotal(item)
            this.$emit('setTotalData', objTotalData)
        },
        getSubTotal(price, discount, outstandings, taxType, tax){
            return getSubTotal(price, discount, outstandings, taxType, tax)
        },

        showAllDetails(){   
            var isExpand = false;
            if(this.isExpand == "Expand"){
                isExpand = true;
                this.isExpand = "Collapse"
            }else{
                isExpand = false;
                this.isExpand = "Expand"
            }
            var detailsContainer = document.getElementById("salesItemTable").querySelectorAll(".salesItemDetail");
            for(var i=0; i<detailsContainer.length; i++){
                if(isExpand){
                    if(detailsContainer[i].style.display == 'none'){
                        detailsContainer[i].style.display = 'block'
                    }
                }else{
                    if(detailsContainer[i].style.display == 'block'){
                        detailsContainer[i].style.display = 'none'
                    }
                }
            }
        },
        showDetails(e){
            var link = e.target.id;
            var detailsDiv = document.getElementById(link).nextSibling;
            detailsDiv.style.display = detailsDiv.style.display == 'none' ? 'block' : 'none';

            var hideCount = 0;
            var detailsContainer = document.getElementById("salesItemTable").querySelectorAll(".salesItemDetail");

            for(var i=0; i<detailsContainer.length; i++){
                if(detailsContainer[i].style.display == 'none'){
                    hideCount++
                }
            }

            this.isExpand = hideCount == this.commissionItems.length ? "Expand" : "Collapse"
        },

        generateReceipt(salesID){
            let $vm = this
            const QUERY_STRING = "/" + salesID + "/receipt";
            const url =  this.$api.REPORT_SALES + QUERY_STRING;

            this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                if(response.status == 200){
                    var path = response.data.path;
                    window.open(path, '_blank');
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            }) 
        },

        setExportData(group, filterObj) {
            var exportData = []
            for (var k = 0; k < group.length; k++) {
                var obj = {
                    '#': k + 1,
                    'Staff': group[k]['staffName'].replaceAll('<b>', '').replaceAll('</b>', '') || '',
                    // 'Position': group[k]['position'] || '',
                    'Type': group[k]['_itemType'] || '',
                    'Sales': this.formatPrice(group[k]['sales']),
                    'Calculation': group[k]['calculation'].replaceAll('<br>', '\n') || '',
                    'Total': this.formatPrice(group[k]['total']),
                }

                exportData.push(obj)
            }

            var strDate = moment(filterObj.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + 'Commission'
            var exportHeaders = [
                this.$msg.REPORT.HEADER + 'Commission',
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet == "all" ? this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) : this.getOutletName(filterObj.outlet)),
                " "];
            var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName,
                exportFields: this.exportFields
            }
            this.$emit('setExportData', data)
        },
    },
    mounted(){
        let $vm = this;
        $vm.commissionItems = $vm.commissionSalesItem
        $vm.getTotalData($vm.commissionItems);
    }
}
</script>
<style scoped>
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}

.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}

.disabled-td{
    background: #e9e9e9;
}
</style>